export const TemplateActionTypes = {
  FETCH_TEMPLATES_START: "FETCH_TEMPLATES_START_NEW",
  FETCH_TEMPLATES_SUCCESS: "FETCH_TEMPLATES_SUCCESS_NEW",
  FETCH_TEMPLATES_FAILURE: "FETCH_TEMPLATES_FAILURE_NEW",
  SET_SEARCH_TEMPLATES_QUERY: "SET_SEARCH_TEMPLATES_QUERY_NEW",
  ADD_SELECTED_TEMPLATE: "ADD_SELECTED_TEMPLATE_NEW",
  DELETE_SELECTED_TEMPLATE: "DELETE_SELECTED_TEMPLATE_NEW",
  SET_SELECTED_TEMPLATE: "SET_SELECTED_TEMPLATE_NEW",
  SET_TEMPLATES_ON_PAGE: "SET_TEMPLATES_ON_PAGE_NEW",
};
